/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerStopModerationMutationResponse,
  TelegramProductsModeratorControllerStopModeration401,
} from '../types/TelegramProductsModeratorControllerStopModeration.ts';

function getTelegramProductsModeratorStopModerationUrl() {
  const res = { method: 'POST', url: `/api/moderator/telegram/products/stop` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/stop}
 */
export async function telegramProductsModeratorStopModeration(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsModeratorControllerStopModerationMutationResponse,
    ResponseErrorConfig<TelegramProductsModeratorControllerStopModeration401>,
    unknown
  >({ method: 'POST', url: getTelegramProductsModeratorStopModerationUrl().url.toString(), ...requestConfig });
  return res.data;
}
